import { FunctionComponent } from 'react'
import useStyles from './styles'
import { DivisorLineProps } from './types'

const DivisorLine: FunctionComponent<DivisorLineProps> = ({
  css,
  vertical,
  ...props
}) => {
  const styles = useStyles({ vertical })

  return <div css={[styles.divisorLine, css]} {...props} />
}

export default DivisorLine
